import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = ["src"];
export default {
  __name: 'ffimg',
  props: {
    alias: {
      type: String,
      "default": ''
    },
    src: {
      type: String,
      "default": ''
    }
  },
  setup: function setup(__props) {
    var _getCurrentInstance = getCurrentInstance(),
      proxy = _getCurrentInstance.proxy;
    var FFdata = reactive({
      imgurl: ''
    });
    var FFprops = __props;
    onMounted(function () {
      if (FFprops.src) {
        FFdata.imgurl = FFprops.src;
      } else if (FFprops.alias) {
        proxy.$common.fetch({
          'act': 'common_infoimg',
          'exts': 'alias=' + FFprops.alias,
          'msg': ''
        }, function (res) {
          FFdata.imgurl = res.infodata ? res.infodata.imgs : '';
        });
      }
    });
    return function (_ctx, _cache) {
      return _unref(FFdata).imgurl ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _unref(FFdata).imgurl
      }, null, 8, _hoisted_1)) : _createCommentVNode("", true);
    };
  }
};